<div class="page-edit">
    <div class="flex save-pnl">
        <button class="button darkblue" style="width: 50%;"
                (click)="cancelSavePage()">
            <span i18n="@@Cancel">Cancel</span>

        </button>
        <button class="button darkblue" style="width: 50%;"
                (click)="savePage()">
            <span *ngIf="page.id==null || page.id<1" i18n="@@Save">Save</span>
            <span *ngIf="page.id!=null && page.id>0" i18n="@@Edit">Edit</span>
        </button>
    </div>
    <p-tabView>
        <p-tabPanel header="page" i18n-header="@@page">
            <div class="page-div block md:flex">
                <div class="right-side col-12 md:col-9">
                    <div class="flex">
                        <div class="col-6 ">
                            <div><label i18n="@@Publish">Publish</label></div>
                            <p-inputSwitch [(ngModel)]="page.active"></p-inputSwitch>
                        </div>
                        <div class="col-2 ">
                            <div><label i18n="@@priority">priority</label></div>
                            <p-inputNumber [min]="0"  [showButtons]="true"  [(ngModel)]="page.priority"></p-inputNumber>
                        </div>
                        <div class="col-2 ">
                            <div><label i18n="@@show Index">show Index</label></div>
                            <p-inputSwitch [(ngModel)]="page.showIndex"></p-inputSwitch>
                        </div>
                    </div>

                    <div class=" p-float-label">
                        <input pInputText style="width: 100%;" [(ngModel)]="page.name">
                        <label i18n="@@name">name</label>
                    </div>

                    <div class="p-float-label">
                        <input pInputText style="width: 100%;" [(ngModel)]="page.title">
                        <label i18n="@@Title">Title</label>
                    </div>
                    <div class="">
                        <label i18n="@@summary">summary</label>
                        <textarea [(ngModel)]="page.summary"></textarea>

                    </div>
                    <label style="margin: 0px 25px" i18n="@@page sections">page sections</label>
                    <ng-container *ngFor="let section of page.pageSections; let i = index;">
                        <div class="page-section">
                            <div class="heade">
                                <p-splitButton label="New Item" i18n-label="@@New Item"
                                               [model]="sectionHeaderItems[i]"
                                               (onDropdownClick)="selectedSection= section"></p-splitButton>
                                <i class="pi pi-trash" (click)="deleteSection(section)"></i>
                                <i *ngIf="i<page.pageSections.length-1" class="pi pi-chevron-down"
                                   (click)="downSection(section)"></i>
                                <i *ngIf="i>0" class="pi pi-chevron-up" (click)="upSection(section)"></i>
                            </div>
                            <div class="section-body" *ngIf="load">
                                <ng-container *ngFor="let item of section.items; let j = index">

                                    <div class="section-header">
                                        <i class="pi pi-trash" (click)="deleteItem(section,item)"></i>
                                        <i *ngIf="accessEditIcon(item)" class="pi pi-pencil" (click)="editItems(item)"></i>
                                        <i class="pi pi-desktop {{item.display_mode == 'lg' ?'selected-icon':''}} " pTooltip="Desktop"
                                           (click)="item.display_mode='lg'"></i>
                                        <i class="pi pi-tablet {{item.display_mode == 'md' ?'selected-icon':''}} " pTooltip="Tablet"
                                           (click)="item.display_mode='md'"></i>
                                        <i class="pi pi-mobile {{item.display_mode == 'sm' ?'selected-icon':''}}"  pTooltip="Mobile"
                                           (click)="item.display_mode='sm'"></i>

                                        <i *ngIf="j<section.items.length-1" class="pi pi-chevron-down"
                                           (click)="downItem(i,item)"></i>
                                        <i *ngIf="j>0" class="pi pi-chevron-up " (click)="upItem(i,item)"></i>
                                    </div>
                                    <ng-template [ngIf]="item.type==='TITLE'">
                                        <div style="padding: 10px;">
                                            <div><label i18n="@@Title">Title</label> :</div>
                                            <div class="flex">
                                                <div style="width: 40px;">
                                                    <i *ngIf="item.body['imgUid'] != null && item.body['imgUid'].length>0"
                                                       style="z-index: 5;position: relative;cursor: pointer;color: red;font-size: 10px;top: -10px;"
                                                       class="pi pi-trash" (click)="item.body['imgUid']=''"></i>
                                                    <img style="width: 40px;top:-28px;position: relative;"
                                                         *ngIf="item.body['imgUid'] != null && item.body['imgUid'].length>0"
                                                         [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +item.body['imgUid'] ">
                                                    <img style="width: 40px;top:-5px;position: relative;"
                                                         (click)="addAuthorImg(section,j)"
                                                         *ngIf="item.body['imgUid']==null || item.body['imgUid'].length<1"
                                                         src="assets/images/user.png">
                                                </div>
                                                <input class="title-item" style="width: calc( 100% - 40px);"
                                                       [(ngModel)]="item.body['text']">
                                            </div>
                                        </div>
                                    </ng-template>
                                    <ng-template [ngIf]="item.type==='TEXT'">
                                        <ngx-suneditor #suneitor (created)="loadEditor(item.body['text'],suneitor)"
                                                       (onChange)="changEditText(item,suneitor)"></ngx-suneditor>
                                    </ng-template>
                                    <ng-template [ngIf]="item.type==='SEPARATOR'">
                                        <div class="separator"></div>
                                    </ng-template>
                                    <ng-template [ngIf]="item.type==='PHOTO'">
                                        <div class="photo-item">
                                            <img [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +item.body['imgUid'] "
                                                 [alt]="item.body['name']"/>
                                        </div>
                                    </ng-template>
                                    <ng-template [ngIf]="item.type==='VIDEO'">
                                        <div class="video-item">
                                            <video controls>
                                                <source src="{{item.body['src']}}"
                                                        type="video/mp4">
                                            </video>
                                        </div>
                                    </ng-template>
                                    <ng-template [ngIf]="item.type==='AUTHOR'">

                                        <div class="author-item">
                                            <div class="author flex ">
                                                <img *ngIf="item.body['imgUid'] != null && item.body['imgUid'].length>0"
                                                     [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +item.body['imgUid'] ">
                                                <img (click)="addAuthorImg(section,j)"
                                                     *ngIf="item.body['imgUid']==null || item.body['imgUid'].length<1"
                                                     src="assets/images/user.png">
                                                <input [(ngModel)]="item.body['name']">
                                                <div> -</div>
                                                <input [(ngModel)]="item.body['desc']">
                                            </div>
                                        </div>
                                    </ng-template>
                                    <ng-template [ngIf]="item.type==='HTML'">
                                        <div class="code-item" style="direction: ltr;">
<!--                                            <ngx-monaco-editor style="min-height: 500px;"-->
<!--                                                               [(ngModel)]="item.body['code']"-->
<!--                                                               [options]="htmlEditorOptions"></ngx-monaco-editor>-->
                                            <textarea style="width: 100%;direction: ltr;min-height: 400px;" pInputText
                                                      [(ngModel)]="item.body['code']"></textarea>
                                        </div>
                                    </ng-template>
                                    <ng-template [ngIf]="item.type==='ACCORDION'">
                                        <div class="flex col-12">
                                            <div class="col-4">
                                                <div>
                                                    <div><label i18n="@@Title">Title</label> :</div>
                                                    <input [(ngModel)]="accordionTemp['title']">
                                                </div>
                                                <div>
                                                    <div><label i18n="@@Text">Text</label> :</div>
                                                    <textarea [(ngModel)]="accordionTemp['text']"></textarea>
                                                </div>
                                                <div>
                                                    <button class="button darkblue"
                                                            (click)="addAccordion(item)">
                                                        <span i18n="@@Add">Add</span>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="col-8">
                                                <p-accordion>
                                                    <p-accordionTab *ngFor="let accordi of item.body['list']; let i=index "  [header]="accordi['title']" >
                                                        <ng-template  pTemplate="header">
                                                            <i style="top: -3px;position: relative;margin: 0px 10px;cursor: pointer;" class="pi pi-trash"
                                                            (click)="removeAccordionFromList(item,i)"></i>
                                                        </ng-template>
                                                        <p>
                                                          {{accordi['text']}}
                                                        </p>
                                                    </p-accordionTab>
                                                </p-accordion>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <ng-template [ngIf]="item.type==='INNER'">
                                        <div class="flex col-12" [innerHTML]="item.body['code'] | safeHtmlPipe" >

                                        </div>
                                    </ng-template>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                    <div class="col-11">
                        <button class="button" style="width: 100%;" (click)="addSection()">
                            <span i18n="@@Add Section">Add Section</span>
                            <i class="pi pi-plus"></i>
                        </button>
                    </div>

                </div>

                <!--                ................................side Panel....................................-->
                <div class="col-12 md:col-3">
                    <!--                    <div>-->
                    <!--                        <div class="div-head" i18n="@@Save">Save</div>-->
                    <!--                        <div style="text-align: center;" class="flex">-->
                    <!--                            <button class="button darkblue" style="width: 50%;"-->
                    <!--                                    (click)="cancelSavePage()">-->
                    <!--                                <span i18n="@@Cancel">Cancel</span>-->

                    <!--                            </button>-->
                    <!--                            <button class="button darkblue" style="width: 50%;"-->
                    <!--                                    (click)="savePage()">-->
                    <!--                                <span *ngIf="page.id==null || page.id<1" i18n="@@Save">Save</span>-->
                    <!--                                <span *ngIf="page.id!=null && page.id>0" i18n="@@Edit">Edit</span>-->
                    <!--                            </button>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <div>
                        <div class="div-head" i18n="@@keywords">keywords</div>
                        <p-chips [(ngModel)]="page.tags"></p-chips>
                    </div>
                    <div class="edit-features">
                        <div class="div-head" i18n="@@features">features</div>
                        <div class="block md:flex md:flex-wrap">
                            <div class="col-12 ">
                                <label style="width: 100%" i18n="@@Type">Type</label>
                                <!--                                <select style="width: 100%" [(ngModel)]="newAttributeValue" >-->
                                <!--                                    <option value=""></option>-->
                                <!--                                    <option value="رنگ">رنگ</option>-->
                                <!--                                    <option value="سایز">سایز</option>-->
                                <!--                                </select>-->
                                <!--                                <p-autoComplete [(ngModel)]="newAttributeValue.attribute"-->
                                <!--                                                [suggestions]="attributeList"-->
                                <!--                                                (completeMethod)="filterAttribute($event)" [optionLabel]="'name'" >-->
                                <!--                                </p-autoComplete>-->
                                <p-dropdown [style]="{'width': '100%'}" [options]="attributeList"
                                            [(ngModel)]="newAttributeValue.attribute"
                                            [filter]="true" (onFilter)="loadListAttribute($event)"
                                            i18n-placeholder="@@Select a Attribute"
                                            placeholder="Select a Attribute"></p-dropdown>


                            </div>
                            <div class="col-12 md:col-10">
                                <label i18n="@@Value">Value</label>
                                <input style="width: 100%;" [(ngModel)]="newAttributeValue.value">
                            </div>
                            <div class="col-12 md:col-2">
                                <i class="pi pi-plus-circle" (click)="addToAttributeValList()"></i>
                            </div>
                            <div class="col-12">
                                <ng-container *ngFor="let val of page.attributeValues; let i = index">
                                    <div class="" style="width:100%;border-bottom: 1px solid #CFD3D9FF">
                                        <span style="font-weight: 500;">{{val.attribute}}</span> :
                                        <span style="padding: 0px 5px;">{{val.value}}</span>
                                        <span><i class="pi pi-times" style="float: inline-end;cursor: pointer"
                                                 (click)="removeAttributeValue(i)"></i></span>
                                    </div>

                                </ng-container>

                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </p-tabPanel>
        <!--//......................Style Tab....................................................................        -->
        <p-tabPanel header="style" i18n-header="@@style">
            <div class="col-12">
                <div class="col-12">
                    <div><label i18n="@@BgColor">BgColor</label></div>
                    <div class="flex">
                        <p-colorPicker [(ngModel)]="page.style.bgColor"></p-colorPicker>
                        <input style="direction: ltr; margin: 0px 5px;" [(ngModel)]="page.style.bgColor">
                    </div>


                </div>
                <div class="col-12">
                    <div><label i18n="@@Select Background Image">Select Background Image</label>
                        <i *ngIf="page.style.bgImage!= null && page.style.bgImage.length>0" style="margin: 0px 10px;"
                           class="pi pi-trash cursor-pointer" (click)="page.style.bgImage=''"></i>
                    </div>
                    <div style="text-align: center;width: 100%;">
                        <img (click)="addStyleBgImage( )"
                             *ngIf="page.style.bgImage != null && page.style.bgImage.length>0"
                             style="width: 100px;border-radius: 10px;"
                             [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +page.style.bgImage ">
                    </div>
                    <div (click)="addStyleBgImage( )" *ngIf="page.style.bgImage==null || page.style.bgImage.length<1">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                             fill="#000000">
                            <path d="M0 0h24v24H0V0z" fill="none"/>
                            <path d="M18 20H4V6h9V4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9zm-7.79-3.17l-1.96-2.36L5.5 18h11l-3.54-4.71zM20 4V1h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V6h3V4h-3z"/>
                        </svg>
                    </div>

                </div>
                <div class="flex">
                    <div class="col-6">
                        <div><label i18n="@@Select Color Logo Image">Select Color Logo Image</label>
                            <i *ngIf="page.style.logoImage!= null && page.style.logoImage.length>0"
                               style="margin: 0px 10px;"
                               class="pi pi-trash cursor-pointer" (click)="page.style.logoImage=''"></i>

                        </div>
                        <div style="text-align: center;width: 100%;">
                            <img class="cursor-pointer" (click)="addStyleLogoImage('logoImage' )"
                                 *ngIf="page.style.logoImage!= null && page.style.logoImage.length>0"
                                 style="width: 100px;border-radius: 10px;"
                                 [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +page.style.logoImage ">
                        </div>
                        <div (click)="addStyleLogoImage( 'logoImage')"
                             *ngIf="page.style.logoImage==null || page.style.logoImage.length<1">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                                 fill="#000000">
                                <path d="M0 0h24v24H0V0z" fill="none"/>
                                <path d="M18 20H4V6h9V4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9zm-7.79-3.17l-1.96-2.36L5.5 18h11l-3.54-4.71zM20 4V1h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V6h3V4h-3z"/>
                            </svg>
                        </div>


                    </div>
                    <div class="col-6">
                        <div><label i18n="@@Select White Logo Image">Select White Logo Image</label>
                            <i *ngIf="page.style.w_logo_image!= null && page.style.w_logo_image.length>0"
                               style="margin: 0px 10px;"
                               class="pi pi-trash cursor-pointer" (click)="page.style.w_logo_image=''"></i>
                        </div>
                        <div style="text-align: center;width: 100%;background-color: #9C9797;">
                            <img class="cursor-pointer" (click)="addStyleLogoImage('wLogoImage' )"
                                 *ngIf="page.style.w_logo_image!= null && page.style.w_logo_image.length>0"
                                 style="width: 100px;border-radius: 10px;"
                                 [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +page.style.w_logo_image ">
                        </div>
                        <div (click)="addStyleLogoImage( 'wLogoImage')"
                             *ngIf="page.style.w_logo_image==null || page.style.w_logo_image.length<1">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                                 fill="#000000">
                                <path d="M0 0h24v24H0V0z" fill="none"/>
                                <path d="M18 20H4V6h9V4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9zm-7.79-3.17l-1.96-2.36L5.5 18h11l-3.54-4.71zM20 4V1h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V6h3V4h-3z"/>
                            </svg>
                        </div>

                    </div>
                </div>
            </div>
        </p-tabPanel>

        <!--.....................Other Field..........................-->
        <p-tabPanel header="Other Fields" i18n-header="@@Other Fields">
            <div *ngIf="page.type=='SUCCESS_STORY'" class="flex flex-wrap">
                <div *ngFor="let ofeild of otherFieldsTitle" class="col-12 lg:col-4">
                    <div><label>{{ofeild}}</label></div>
                    <input pInputText style="width: 100%" [(ngModel)]="page.otherFields[ofeild]">
                </div>
                <!--                <div class="col-12 lg:col-4">-->
                <!--                    <div><label i18n="@@Number of employees">Number of employees</label></div>-->
                <!--                    <input pInputText style="width: 100%" [(ngModel)]="page.otherFields[getTranslat('Number of employees')]">-->
                <!--                </div>-->
                <!--                <div class="col-12 lg:col-4">-->
                <!--                    <div><label i18n="@@Start Cooperation">Start Cooperation</label></div>-->
                <!--                    <input pInputText style="width: 100%" [(ngModel)]="page.otherFields[getTranslat('Start Cooperation')]">-->
                <!--                </div>-->
            </div>

        </p-tabPanel>
    </p-tabView>
</div>


<p-dialog i18n-header="@@Image Manager" header="Image Manager" [resizable]="false"
          [(visible)]="displayImageCenter"
          showEffect="fade" [modal]="true" [closable]="true" [style]="{'width':'90%'}">
    <div class="  lg:col-12">
        <app-image-manager [imgSelected]="imgManagerTemp"
                           (selectImageEvent)="selectPhotoItem($event)"></app-image-manager>
    </div>
</p-dialog>
<p-dialog i18n-header="@@Video Manager" header="Video Manager" [resizable]="false"
          [(visible)]="displayVideoCenter"
          showEffect="fade" [modal]="true" [closable]="true" [style]="{'width':'60vw'}">
    <div class="  lg:col-12" style="direction: ltr;">
        <div><label>src</label> :</div>
        <input class="title-item" style="width: 100%;" [(ngModel)]="videoSrcTemp">
    </div>
    <p-footer>
        <button class="button" (click)="addVideo()">
            <span i18n="@@Add"> Add</span>
            <i class="pi pi-plus"></i>
        </button>
    </p-footer>
</p-dialog>
<p-dialog  header="HTML" [resizable]="false"
          [(visible)]="displayInnerHtml"
          showEffect="fade" [modal]="true" [closable]="true" [style]="{'width':'60vw'}">
    <div class="  lg:col-12" style="direction: ltr;">
        <div><label>html</label> :</div>
        <textarea class="title-item" style="width: 100%;" [(ngModel)]="htmlCode"></textarea>
    </div>
    <p-footer>
        <button class="button" (click)="addInner()">
            <span i18n="@@Add"> Add</span>
            <i class="pi pi-plus"></i>
        </button>
    </p-footer>
</p-dialog>
